import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

// Superseded by setRouteAuthPolicy, which controls `public` and `external_id`
// independently. Retained for the expand/contract window so a stale client
// running the cached bundle keeps working; it forwards the single toggle to
// both new columns (the pre-split behavior), which is what enforcement reads.
// Remove once no stale clients remain (add to ALLOWED_REMOVALS then).
//
// `previousDisabled` exists so the audit log records the transition, not just
// the new value; verifying it against the row keeps the log truthful and
// rejects a toggle racing another admin's change.
const setPublicRouteAuthDisabledSchema = z.object({
  disabled: z.boolean(),
  previousDisabled: z.boolean(),
});

export const setPublicRouteAuthDisabled = mutator({
  schema: setPublicRouteAuthDisabledSchema,
  resolve: {},
  permissions: [
    { permission: "allow_all", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { disabled, previousDisabled } }) => {
    const tenant = await tx.run(zql.tenants.where("id", ctx.tenantId).one());
    if ((tenant?.publicWebpageAuthDisabled ?? false) !== previousDisabled) {
      throw userFacingError(
        "The setting changed since you loaded it — try again"
      );
    }
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      publicRouteAuthDisabled: disabled,
      publicWebpageAuthDisabled: disabled,
      externalIdWebpageAuthDisabled: disabled,
      publicNonWebpageAuthDisabled: disabled,
      updatedAt: Date.now(),
    });
  },
});
